const resources = {
    shopThisPost: 'Shop This Post'
};

export default function getResource(label) {
    return resources[label];
}
